//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { videoPlayer } from 'vue-video-player'
import 'jquery'
export default {
  mounted: function () {
    var body = $('body')
    body.removeClass('scrollhidden')
    window.scrollTo(0, 0)
  },
  data () {
    return {
      playerOptions: {
        height: '681',
        playbackRates: [0.7, 1, 1.3, 1.5, 1.7],
        sources: [{
          type: 'video/mp4',
          src: 'http://114.215.45.205:8088/Movie_02_V.mp4'
        }],
        poster: 'http://www.icloudpay.me/static/pic/bus.png'
      }
    }
  },
  components: {
    videoPlayer
  },
  methods: {
    selectCity: function (item) {
      this.selectCityItem = item
      if (item === '首页') {
        this.$destroy()
        this.$router.push({path: '/'})
      } else if (item === '产品介绍') {
        this.$destroy()
        this.$router.push({path: 'productinfo'})
      } else if (item === '联系我们') {
        this.$destroy()
        this.$router.push({path: 'contact'})
      } else if (item === '新闻动态') {
        this.$destroy()
        this.$router.push({path: 'newDy'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Guanwang/newdetial2.vue